import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as actions from "../../actions/acBookingFlow"
import { PootsyButton, PootsyTitle } from "../DesignFunctions";
import { PootsyCheckboxInput } from "../InputsFunctions"
import download from '../../static/img/download.png'
import WorkerContainer from "./WorkerContainer"
import { API_ROOT } from '../../config'
import moment from "moment"


class BookingFlowConfirmation extends Component {

	render() {
		let { t } = this.context

		let { selectedTimeSlot, frequency, selectedResidence, voucherType } = this.props.data
		let startTime = moment(selectedTimeSlot.startTime)
		let endTime = moment(selectedTimeSlot.endTime)
		let duration = endTime.diff(startTime, 'hours')
		let worker = selectedTimeSlot.worker
		let address = selectedResidence.address

		let { affiliateName, affiliateId } = worker
		let { acceptCGU, acceptConvention } = this.props.metadata

		let language = this.props.profile.lang

		let canSubmit = acceptCGU && acceptConvention

		let conventionURL = `${API_ROOT}/api/v1/customers/affiliate_conventions/${affiliateId}?language=${language}`

		let rows = [
			{ label: t('booking_flow_confirmation_date'), value: startTime.format('DD.MM.YYYY') },
			{
				label: t('booking_flow_confirmation_time_slot'),
				value: t('booking_flow_confirmation_time_slot_value', {
					start: startTime.format('HH:mm'),
					end: endTime.format('HH:mm'),
					duration: duration
				})
			},
			{ label: t('booking_flow_confirmation_frequency'), value: t(this.getFrequencyValue(frequency)) },
			{
				label: t('booking_flow_confirmation_price'),
				value: t('booking_flow_confirmation_price_value', { price: (9 * duration), voucher_count: duration })
			},
			{
				label: t('booking_flow_confirmation_voucher_type'),
				value: t('booking_flow_sodexo_voucher_type_' + voucherType)
			},
			{
				label: t('booking_flow_confirmation_address'),
				value: address.streetName + ', ' + address.streetNumber + '\n' + address.zipCode + ' ' + address.city
			}
		]

		return (
			<div className="BookingFlowConfirmation">
				<div className="left">
					<div className="title">{t('booking_flow_confirmation_title')}</div>
					<WorkerContainer worker={worker}/>
					{rows.map((row, index) => this.renderRow(row.label, row.value, index !== (rows.length - 1)))}
				</div>
				<div className="right">
					<div className="container">
						<PootsyTitle title={t('booking_confirmation_convention_title') + ' ' + affiliateName}/>
						<div className="description">{t('booking_confirmation_convention_decription')}</div>
						<div className="download-convention">
							<a href={conventionURL} target="_blank">
								<div>{t('booking_confirmation_download_convention')}</div>
								<img src={download} alt="download"/>
							</a>
						</div>
						<PootsyCheckboxInput label={t('accept_cgu')}
											 name="accept_cgu"
											 checked={acceptCGU}
											 onChange={this.onChangeCGU}
						/>
						<PootsyCheckboxInput label={t('accept_convention')}
											 name="accept_convention"
											 checked={acceptConvention}
											 onChange={this.onChangeConvention}
						/>
						<PootsyButton text={t('confirm')}
									  onClick={this.onConfirmButtonClick}
									  disabled={!canSubmit}
						/>
					</div>
				</div>
			</div>
		)
	}

	renderRow = (label, value, displayDivider) => {
		return [
			<div className="row" key="0">
				<div className="label">{label}</div>
				<div className="value">{value}</div>
			</div>,
			displayDivider && <div className="divider" key="1"/>
		]
	}

	getFrequencyValue = (frequencyId) => {
		switch (frequencyId) {
			case 0:
				return 'booking_flow_frequency_once'
			case 1:
				return 'booking_flow_frequency_every_week'
			case 2:
				return 'booking_flow_frequency_every_two_weeks'
			default:
				return 'booking_flow_frequency_once'
		}
	}

	onChangeCGU = e => {
		this.props.dispatch(actions.bookingFlowMetaChange({ acceptCGU: e.target.checked }))
	}

	onChangeConvention = e => {
		this.props.dispatch(actions.bookingFlowMetaChange({ acceptConvention: e.target.checked }))
	}

	onConfirmButtonClick = () => {
		this.props.dispatch(actions.bookingFlowValidateConfirmationStep())
	}
}

BookingFlowConfirmation.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	data: state.dataReducer.bookingFlow,
	metadata: state.metadataReducer.bookingFlow,
	profile: state.dataReducer.accountProfile
})
export default connect(mapStateToProps)(BookingFlowConfirmation);


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowConfirmation.js